import { type ArticuloRequest, type ArticuloFormErrors } from '../types/articulo';

export class ArticuloValidation {
  public static validateArticulo(articulo: ArticuloRequest): ArticuloFormErrors {
    const errors: ArticuloFormErrors = {};

    if (!articulo.descripcion?.trim()) {
      errors.descripcion = 'La descripción es requerida';
    } else if (articulo.descripcion.length > 200) {
      errors.descripcion = 'La descripción no puede exceder 200 caracteres';
    }

    if (articulo.codigo && articulo.codigo.length > 50) {
      errors.codigo = 'El código no puede exceder 50 caracteres';
    }

    if (articulo.marca && articulo.marca.length > 100) {
      errors.marca = 'La marca no puede exceder 100 caracteres';
    }

    if (articulo.modelo && articulo.modelo.length > 100) {
      errors.modelo = 'El modelo no puede exceder 100 caracteres';
    }

    if (articulo.precio !== undefined && articulo.precio < 0) {
      errors.precio = 'El precio no puede ser negativo';
    }

    return errors;
  }

  public static hasValidationErrors(errors: ArticuloFormErrors): boolean {
    return Object.keys(errors).length > 0;
  }
}